var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

import { ReactSVGPanZoom, TOOL_NONE, TOOL_PAN, TOOL_ZOOM_IN, TOOL_ZOOM_OUT, TOOL_AUTO, INITIAL_VALUE } from 'react-svg-pan-zoom';
import * as constants from '../../constants';
import State from './state';
import * as SharedStyle from '../../shared-style';
import { RulerX, RulerY } from './export';

function mode2Tool(mode) {
  switch (mode) {
    case constants.MODE_2D_PAN:
      return TOOL_PAN;
    case constants.MODE_2D_ZOOM_IN:
      return TOOL_ZOOM_IN;
    case constants.MODE_2D_ZOOM_OUT:
      return TOOL_ZOOM_OUT;
    case constants.MODE_IDLE:
      return TOOL_AUTO;
    case constants.MODE_AXONOMETRIC:
      return TOOL_AUTO;
    default:
      return TOOL_NONE;
  }
}

function mode2PointerEvents(mode) {
  switch (mode) {
    case constants.MODE_DRAWING_LINE:
    case constants.MODE_DRAWING_HOLE:
    case constants.MODE_DRAWING_ITEM:
    case constants.MODE_DRAGGING_HOLE:
    case constants.MODE_DRAGGING_ITEM:
    case constants.MODE_DRAGGING_LINE:
    case constants.MODE_DRAGGING_VERTEX:
    case constants.MODE_DRAWING_AREA:
    case constants.MODE_DRAGGING_AREA:
    case constants.MODE_DRAWING_PIPE:
    case constants.MODE_DRAGGING_PIPE:
      return { pointerEvents: 'none' };

    default:
      return {};
  }
}

function mode2Cursor(mode) {
  switch (mode) {
    case constants.MODE_DRAGGING_HOLE:
    case constants.MODE_DRAGGING_LINE:
    case constants.MODE_DRAGGING_VERTEX:
    case constants.MODE_DRAGGING_ITEM:
    case constants.MODE_DRAGGING_AREA:
    case constants.MODE_DRAGGING_PIPE:
      return { cursor: 'move' };

    case constants.MODE_ROTATING_ITEM:
      return { cursor: 'ew-resize' };

    case constants.MODE_WAITING_DRAWING_LINE:
    case constants.MODE_DRAWING_LINE:
    case constants.MODE_WAITING_DRAWING_PIPE:
    case constants.MODE_DRAWING_PIPE:
    case constants.MODE_DRAWING_AREA:
      return { cursor: 'crosshair' };
    case constants.MODE_2D_ZOOM_IN:
      return { cursor: 'zoom-in' };
    case constants.MODE_2D_ZOOM_OUT:
      return { cursor: 'zoom-out' };
    default:
      return { cursor: 'default' };
  }
}

function mode2DetectAutopan(mode) {
  switch (mode) {
    case constants.MODE_DRAWING_LINE:
    case constants.MODE_DRAGGING_LINE:
    case constants.MODE_DRAGGING_VERTEX:
    case constants.MODE_DRAGGING_HOLE:
    case constants.MODE_DRAGGING_ITEM:
    case constants.MODE_DRAWING_HOLE:
    case constants.MODE_DRAWING_ITEM:
    case constants.MODE_DRAWING_AREA:
    case constants.MODE_DRAGGING_AREA:
    case constants.MODE_DRAWING_PIPE:
    case constants.MODE_DRAGGING_PIPE:
      return true;

    default:
      return false;
  }
}

function extractElementData(node) {
  while (!node.attributes.getNamedItem('data-element-root') && node.tagName !== 'svg') {
    node = node.parentNode;
  }
  if (node.tagName === 'svg') return null;

  return {
    part: node.attributes.getNamedItem('data-part') ? node.attributes.getNamedItem('data-part').value : undefined,
    layer: node.attributes.getNamedItem('data-layer').value,
    prototype: node.attributes.getNamedItem('data-prototype').value,
    selected: node.attributes.getNamedItem('data-selected').value === 'true',
    id: node.attributes.getNamedItem('data-id').value
  };
}

var ViewerAxonometric = function (_React$Component) {
  _inherits(ViewerAxonometric, _React$Component);

  function ViewerAxonometric(props, context) {
    _classCallCheck(this, ViewerAxonometric);

    var _this = _possibleConstructorReturn(this, (ViewerAxonometric.__proto__ || Object.getPrototypeOf(ViewerAxonometric)).call(this, props, context));

    _this.state = {};
    return _this;
  }

  _createClass(ViewerAxonometric, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.Viewer.fitToViewer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          state = _props.state,
          width = _props.width,
          height = _props.height;
      var _context = this.context,
          viewer2DActions = _context.viewer2DActions,
          linesActions = _context.linesActions,
          holesActions = _context.holesActions,
          verticesActions = _context.verticesActions,
          itemsActions = _context.itemsActions,
          areaActions = _context.areaActions,
          projectActions = _context.projectActions,
          catalog = _context.catalog,
          pipesActions = _context.pipesActions;
      var viewer2D = state.viewer2D,
          mode = state.mode,
          scene = state.scene;


      var layerID = scene.selectedLayer;

      var mapCursorPosition = function mapCursorPosition(_ref) {
        var x = _ref.x,
            y = _ref.y;

        return { x: x, y: -y + scene.height };
      };

      var mapFingerPosition = function mapFingerPosition(_ref2) {
        var x = _ref2.x,
            y = _ref2.y;

        return { x: x, y: -y + scene.height };
      };

      var onTouchStart = function onTouchStart(viewerEvent) {
        var event = viewerEvent.originalEvent;
        //workaround that allow imageful component to work
        var evt = new Event('touchStart-planner-event');
        evt.viewerEvent = viewerEvent;
        document.dispatchEvent(evt);

        // workaround for zoom in zoom out with two fingers
        if (viewerEvent.points.length > 1) {
          return;
        }

        var _mapFingerPosition = mapFingerPosition(viewerEvent.points[0]),
            x = _mapFingerPosition.x,
            y = _mapFingerPosition.y;

        projectActions.updateMouseCoord({ x: x, y: y });
        if (mode === constants.MODE_IDLE) {
          var elementData = extractElementData(event.target);
          if (!elementData || !elementData.selected) return;

          switch (elementData.prototype) {
            case 'lines':
              linesActions.beginDraggingLine(elementData.layer, elementData.id, x, y, state.snapMask);
              break;

            case 'vertices':
              verticesActions.beginDraggingVertex(elementData.layer, elementData.id, x, y, state.snapMask);
              break;

            case 'items':
              if (elementData.part === 'rotation-anchor') itemsActions.beginRotatingItem(elementData.layer, elementData.id, x, y);else if (elementData.part === 'resize-anchor-width') itemsActions.beginResizingItem(elementData.layer, elementData.id, x, y, 'width');else if (elementData.part === 'resize-anchor-depth') itemsActions.beginResizingItem(elementData.layer, elementData.id, x, y, 'depth');else itemsActions.beginDraggingItem(elementData.layer, elementData.id, x, y);
              break;

            case 'holes':
              if (elementData.part === 'resize-anchor-width') holesActions.beginResizingHole(elementData.layer, elementData.id, x, y, 'width');else if (elementData.part === 'resize-anchor-thickness') {
                holesActions.beginResizingHole(elementData.layer, elementData.id, x, y, 'thickness');
              } else holesActions.beginDraggingHole(elementData.layer, elementData.id, x, y);
              break;

            case 'areas':
              areaActions.beginDraggingArea(elementData.layer, elementData.id, x, y);
              break;

            case 'pipes':
              pipesActions.beginDraggingPipe(elementData.layer, elementData.id, x, y, state.snapMask);
              break;

            default:
              break;
          }
        }

        // if (mode === constants.MODE_WAITING_DRAWING_LINE) {
        //   linesActions.beginDrawingLine(layerID, x, y, state.snapMask);
        // }

        onTouchMove(viewerEvent);
        event.stopPropagation();
      };

      var onTouchEnd = function onTouchEnd(viewerEvent) {
        var event = viewerEvent.originalEvent;

        var evt = new Event('touchend-planner-event');
        evt.viewerEvent = viewerEvent;
        document.dispatchEvent(evt);
        var x = state.getIn(['mouse', 'x']);
        var y = state.getIn(['mouse', 'y']);

        switch (mode) {

          case constants.MODE_IDLE:
            var elementData = extractElementData(event.target);

            if (elementData && elementData.selected) return;

            switch (elementData ? elementData.prototype : 'none') {
              case 'areas':
                areaActions.selectArea(elementData.layer, elementData.id);
                break;

              case 'lines':
                linesActions.selectLine(elementData.layer, elementData.id);
                break;

              case 'holes':
                holesActions.selectHole(elementData.layer, elementData.id);
                break;

              case 'items':
                itemsActions.selectItem(elementData.layer, elementData.id);
                break;

              case 'pipes':
                pipesActions.selectPipe(elementData.layer, elementData.id);
                break;

              case 'none':
                projectActions.unselectAll();
                break;
            }
            break;

          case constants.MODE_DRAWING_PIPE:
            pipesActions.endDrawingPipe(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_PIPE:
            pipesActions.endDraggingPipe(x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_LINE:
            linesActions.endDrawingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_HOLE:
            holesActions.endDrawingHole(layerID, x, y);
            break;

          case constants.MODE_DRAWING_ITEM:
            itemsActions.endDrawingItem(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_LINE:
            linesActions.endDraggingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_VERTEX:
            verticesActions.endDraggingVertex(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_ITEM:
            itemsActions.endDraggingItem(x, y);
            break;

          case constants.MODE_DRAGGING_HOLE:
            holesActions.endDraggingHole(x, y);
            break;

          case constants.MODE_ROTATING_ITEM:
            itemsActions.endRotatingItem(x, y);
            break;

          case constants.MODE_DRAWING_AREA:
            areaActions.endDrawingArea(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_AREA:
            areaActions.endDraggingArea(x, y);
            break;

          case constants.MODE_RESIZING_ITEM:
            itemsActions.endResizingItem(x, y);
            break;

          case constants.MODE_RESIZING_HOLE:
            holesActions.endResizingHole(x, y);
            break;
        }

        event.stopPropagation();
      };

      var onTouchMove = function onTouchMove(event) {
        // workaround for zoom in zoom out with two fingers
        if (event.points.length > 1) {
          return;
        }

        var _mapFingerPosition2 = mapFingerPosition(event.points[0]),
            x = _mapFingerPosition2.x,
            y = _mapFingerPosition2.y;

        projectActions.updateMouseCoord({ x: x, y: y });

        switch (mode) {
          case constants.MODE_DRAWING_LINE:
            linesActions.updateDrawingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_HOLE:
            holesActions.updateDrawingHole(layerID, x, y);
            break;

          case constants.MODE_DRAWING_ITEM:
            itemsActions.updateDrawingItem(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_HOLE:
            holesActions.updateDraggingHole(x, y);
            break;

          case constants.MODE_DRAGGING_LINE:
            linesActions.updateDraggingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_VERTEX:
            verticesActions.updateDraggingVertex(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_ITEM:
            itemsActions.updateDraggingItem(x, y);
            break;

          case constants.MODE_ROTATING_ITEM:
            itemsActions.updateRotatingItem(x, y);
            break;

          case constants.MODE_DRAWING_AREA:
            areaActions.updateDrawingArea(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_AREA:
            areaActions.updateDraggingArea(x, y);
            break;

          case constants.MODE_RESIZING_ITEM:
            itemsActions.updateResizingItem(x, y);
            break;

          case constants.MODE_RESIZING_HOLE:
            holesActions.updateResizingHole(x, y);
            break;

          case constants.MODE_DRAWING_PIPE:
            pipesActions.updateDrawingPipe(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_PIPE:
            pipesActions.updateDraggingPipe(x, y, state.snapMask);
            break;

        }

        event.originalEvent.stopPropagation();
      };

      var onMouseMove = function onMouseMove(viewerEvent) {
        //workaround that allow imageful component to work
        var evt = new Event('mousemove-planner-event');
        evt.viewerEvent = viewerEvent;
        document.dispatchEvent(evt);

        var _mapCursorPosition = mapCursorPosition(viewerEvent),
            x = _mapCursorPosition.x,
            y = _mapCursorPosition.y;

        projectActions.updateMouseCoord({ x: x, y: y });

        switch (mode) {
          case constants.MODE_DRAWING_LINE:
            linesActions.updateDrawingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_HOLE:
            holesActions.updateDrawingHole(layerID, x, y);
            break;

          case constants.MODE_DRAWING_ITEM:
            itemsActions.updateDrawingItem(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_HOLE:
            holesActions.updateDraggingHole(x, y);
            break;

          case constants.MODE_DRAGGING_LINE:
            linesActions.updateDraggingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_VERTEX:
            verticesActions.updateDraggingVertex(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_ITEM:
            itemsActions.updateDraggingItem(x, y);
            break;

          case constants.MODE_ROTATING_ITEM:
            itemsActions.updateRotatingItem(x, y);
            break;

          case constants.MODE_DRAWING_AREA:
            areaActions.updateDrawingArea(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_AREA:
            areaActions.updateDraggingArea(x, y);
            break;

          case constants.MODE_RESIZING_ITEM:
            itemsActions.updateResizingItem(x, y);
            break;

          case constants.MODE_RESIZING_HOLE:
            holesActions.updateResizingHole(x, y);
            break;

          case constants.MODE_DRAWING_PIPE:
            pipesActions.updateDrawingPipe(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_PIPE:
            pipesActions.updateDraggingPipe(x, y, state.snapMask);
            break;
        }

        viewerEvent.originalEvent.stopPropagation();
      };

      var onMouseDown = function onMouseDown(viewerEvent) {
        var event = viewerEvent.originalEvent;

        //workaround that allow imageful component to work
        var evt = new Event('mousedown-planner-event');
        evt.viewerEvent = viewerEvent;
        document.dispatchEvent(evt);

        var _mapCursorPosition2 = mapCursorPosition(viewerEvent),
            x = _mapCursorPosition2.x,
            y = _mapCursorPosition2.y;

        if (mode === constants.MODE_IDLE) {
          var elementData = extractElementData(event.target);
          if (!elementData || !elementData.selected) return;

          switch (elementData.prototype) {
            case 'lines':
              linesActions.beginDraggingLine(elementData.layer, elementData.id, x, y, state.snapMask);
              break;

            case 'vertices':
              verticesActions.beginDraggingVertex(elementData.layer, elementData.id, x, y, state.snapMask);
              break;

            case 'items':
              if (elementData.part === 'rotation-anchor') itemsActions.beginRotatingItem(elementData.layer, elementData.id, x, y);else if (elementData.part === 'resize-anchor-width') itemsActions.beginResizingItem(elementData.layer, elementData.id, x, y, 'width');else if (elementData.part === 'resize-anchor-depth') itemsActions.beginResizingItem(elementData.layer, elementData.id, x, y, 'depth');else itemsActions.beginDraggingItem(elementData.layer, elementData.id, x, y);
              break;

            case 'holes':
              if (elementData.part === 'resize-anchor-width') holesActions.beginResizingHole(elementData.layer, elementData.id, x, y, 'width');else if (elementData.part === 'resize-anchor-thickness') {
                holesActions.beginResizingHole(elementData.layer, elementData.id, x, y, 'thickness');
              } else holesActions.beginDraggingHole(elementData.layer, elementData.id, x, y);
              break;

            case 'areas':
              areaActions.beginDraggingArea(elementData.layer, elementData.id, x, y);
              break;

            case 'pipes':
              pipesActions.beginDraggingPipe(elementData.layer, elementData.id, x, y, state.snapMask);
              break;

            default:
              break;
          }
        }
        event.stopPropagation();
      };

      var onMouseUp = function onMouseUp(viewerEvent) {
        var event = viewerEvent.originalEvent;

        var evt = new Event('mouseup-planner-event');
        evt.viewerEvent = viewerEvent;
        document.dispatchEvent(evt);

        var _mapCursorPosition3 = mapCursorPosition(viewerEvent),
            x = _mapCursorPosition3.x,
            y = _mapCursorPosition3.y;

        switch (mode) {

          case constants.MODE_IDLE:
            var elementData = extractElementData(event.target);

            if (elementData && elementData.selected) return;

            switch (elementData ? elementData.prototype : 'none') {
              case 'areas':
                areaActions.selectArea(elementData.layer, elementData.id);
                break;

              case 'lines':
                linesActions.selectLine(elementData.layer, elementData.id);
                break;

              case 'pipes':
                pipesActions.selectPipe(elementData.layer, elementData.id);
                break;

              case 'holes':
                holesActions.selectHole(elementData.layer, elementData.id);
                break;

              case 'items':
                itemsActions.selectItem(elementData.layer, elementData.id);
                break;

              case 'none':
                projectActions.unselectAll();
                break;
            }
            break;

          case constants.MODE_WAITING_DRAWING_LINE:
            linesActions.beginDrawingLine(layerID, x, y, state.snapMask);
            break;

          case constants.MODE_WAITING_DRAWING_PIPE:
            pipesActions.beginDrawingPipe(layerID, x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_LINE:
            linesActions.endDrawingLine(x, y, state.snapMask);
            //linesActions.beginDrawingLine(layerID, x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_PIPE:
            pipesActions.endDrawingPipe(x, y, state.snapMask);
            break;

          case constants.MODE_DRAWING_HOLE:
            holesActions.endDrawingHole(layerID, x, y);
            break;

          case constants.MODE_DRAWING_ITEM:
            itemsActions.endDrawingItem(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_LINE:
            linesActions.endDraggingLine(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_PIPE:
            pipesActions.endDraggingPipe(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_VERTEX:
            verticesActions.endDraggingVertex(x, y, state.snapMask);
            break;

          case constants.MODE_DRAGGING_ITEM:
            itemsActions.endDraggingItem(x, y);
            break;

          case constants.MODE_DRAGGING_HOLE:
            holesActions.endDraggingHole(x, y);
            break;

          case constants.MODE_ROTATING_ITEM:
            itemsActions.endRotatingItem(x, y);
            break;

          case constants.MODE_DRAWING_AREA:
            areaActions.endDrawingArea(layerID, x, y);
            break;

          case constants.MODE_DRAGGING_AREA:
            areaActions.endDraggingArea(x, y);
            break;

          case constants.MODE_RESIZING_ITEM:
            itemsActions.endResizingItem(x, y);
            break;

          case constants.MODE_RESIZING_HOLE:
            holesActions.endResizingHole(x, y);
            break;
        }

        event.stopPropagation();
      };

      var onChangeValue = function onChangeValue(value) {
        projectActions.updateZoomScale(value.a);
        return viewer2DActions.updateCameraView(value);
      };

      var onChangeTool = function onChangeTool(tool) {
        switch (tool) {
          case TOOL_NONE:
            projectActions.selectToolEdit();
            break;

          case TOOL_PAN:
            viewer2DActions.selectToolPan();
            break;

          case TOOL_ZOOM_IN:
            viewer2DActions.selectToolZoomIn();
            break;

          case TOOL_ZOOM_OUT:
            viewer2DActions.selectToolZoomOut();
            break;
        }
      };

      var _state$get$toJS = state.get('viewer2D').toJS(),
          e = _state$get$toJS.e,
          f = _state$get$toJS.f,
          SVGWidth = _state$get$toJS.SVGWidth,
          SVGHeight = _state$get$toJS.SVGHeight;

      var rulerSize = 15; //px
      var rulerUnitPixelSize = 100;
      var rulerBgColor = SharedStyle.PRIMARY_COLOR.main;
      var rulerFnColor = SharedStyle.COLORS.white;
      var rulerMkColor = SharedStyle.SECONDARY_COLOR.main;
      var sceneWidth = SVGWidth || state.getIn(['scene', 'width']);
      var sceneHeight = SVGHeight || state.getIn(['scene', 'height']);
      var sceneZoom = state.zoom || 1;
      var rulerXElements = Math.ceil(sceneWidth / rulerUnitPixelSize) + 1;
      var rulerYElements = Math.ceil(sceneHeight / rulerUnitPixelSize) + 1;
      var minitiatureProps = {
        position: "none"
      };

      var toolbarProps = {
        position: "none"
      };

      return React.createElement(
        'div',
        { style: {
            margin: 0,
            padding: 0,
            display: 'grid',
            gridRowGap: '0',
            gridColumnGap: '0',
            gridTemplateColumns: rulerSize + 'px ' + (width - rulerSize) + 'px',
            gridTemplateRows: rulerSize + 'px ' + (height - rulerSize) + 'px',
            position: 'relative'
          } },
        React.createElement('div', { style: { gridColumn: 1, gridRow: 1, backgroundColor: rulerBgColor } }),
        React.createElement(
          'div',
          { style: { gridRow: 1, gridColumn: 2, position: 'relative', overflow: 'hidden' }, id: 'rulerX' },
          sceneWidth ? React.createElement(RulerX, {
            unitPixelSize: rulerUnitPixelSize,
            zoom: sceneZoom,
            mouseX: state.mouse.get('x') || 0,
            width: width - rulerSize,
            zeroLeftPosition: e || 0,
            backgroundColor: rulerBgColor,
            fontColor: rulerFnColor,
            markerColor: rulerMkColor,
            positiveUnitsNumber: rulerXElements,
            negativeUnitsNumber: 0
          }) : null
        ),
        React.createElement(
          'div',
          { style: { gridColumn: 1, gridRow: 2, position: 'relative', overflow: 'hidden' }, id: 'rulerY' },
          sceneHeight ? React.createElement(RulerY, {
            unitPixelSize: rulerUnitPixelSize,
            zoom: sceneZoom,
            mouseY: state.mouse.get('y') || 0,
            height: height - rulerSize,
            zeroTopPosition: sceneHeight * sceneZoom + f || 0,
            backgroundColor: rulerBgColor,
            fontColor: rulerFnColor,
            markerColor: rulerMkColor,
            positiveUnitsNumber: rulerYElements,
            negativeUnitsNumber: 0
          }) : null
        ),
        React.createElement(
          ReactSVGPanZoom,
          {
            ref: function ref(Viewer) {
              return _this2.Viewer = Viewer;
            },
            style: { gridColumn: 2, gridRow: 2 },
            width: width - rulerSize,
            height: height - rulerSize,
            value: viewer2D.isEmpty() ? INITIAL_VALUE : viewer2D.toJS(),
            onChangeValue: onChangeValue,
            tool: mode2Tool(mode),
            onChangeTool: onChangeTool,
            detectAutoPan: mode2DetectAutopan(mode),
            onMouseDown: onMouseDown,
            onMouseMove: onMouseMove,
            onMouseUp: onMouseUp,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            miniatureProps: minitiatureProps,
            toolbarProps: toolbarProps,
            scaleFactorMin: constants.MIN_ZOOM,
            scaleFactorMax: constants.MAX_ZOOM
          },
          React.createElement(
            'svg',
            { width: scene.width + scene.width / 2.22, height: scene.height + 200 },
            React.createElement(
              'defs',
              null,
              React.createElement(
                'pattern',
                { id: 'diagonalFill', patternUnits: 'userSpaceOnUse', width: '4', height: '4', fill: '#FFF' },
                React.createElement('rect', { x: '0', y: '0', width: '4', height: '4', fill: '#FFF' }),
                React.createElement('path', { d: 'M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2', style: { stroke: '#8E9BA2', strokeWidth: .5 } })
              )
            ),
            React.createElement(
              'g',
              { style: Object.assign(mode2Cursor(mode), mode2PointerEvents(mode)) },
              React.createElement(State, { state: state, catalog: catalog })
            )
          )
        )
      );
    }
  }]);

  return ViewerAxonometric;
}(React.Component);

export default ViewerAxonometric;


ViewerAxonometric.propTypes = {
  state: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
};

ViewerAxonometric.contextTypes = {
  viewer2DActions: PropTypes.object.isRequired,
  linesActions: PropTypes.object.isRequired,
  holesActions: PropTypes.object.isRequired,
  verticesActions: PropTypes.object.isRequired,
  itemsActions: PropTypes.object.isRequired,
  areaActions: PropTypes.object.isRequired,
  projectActions: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  pipesActions: PropTypes.object.isRequired
};